import SetAsCurrentStage from './SetAsCurrentStage';
import './SetAsCurrentStage.scss';

export default SetAsCurrentStage;
